// from: https://stackoverflow.com/a/37562814/5221762
export function toFormUrlEncoded(args) {
    const formBody = [];
    for (const key in args) {
        if (Object.prototype.hasOwnProperty.call(args, key) && args[key] != null) {
            const encodedKey = encodeURIComponent(key);
            const encodedValue = encodeURIComponent(args[key]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
    }
    return formBody.join('&');
}
export function toFormData(args) {
    const formData = new FormData();
    for (const key in args) {
        if (Object.prototype.hasOwnProperty.call(args, key) && args[key] != null) {
            const value = args[key];
            if (Array.isArray(value)) {
                for (let i = 0, len = value.length; i < len; i++) {
                    formData.append(key, value[i]);
                }
            }
            else {
                formData.append(key, value);
            }
        }
    }
    return formData;
}
